import BookingTab from '@v/bookings/details/tabs/tab-booking/BookingTab.vue'
import CustomerTab from '@v/bookings/details/tabs/tab-customer/CustomerTab.vue'
import VisitorsTab from '@v/bookings/details/tabs/tab-visitors/VisitorsTab.vue'
import NotesTab from '@v/bookings/details/tabs/tab-notes/NotesTab.vue'
import PaymentsTab from '@v/bookings/details/tabs/tab-payments/PaymentsTab.vue'
import MailsTab from '@v/bookings/details/tabs/tab-mails/MailsTab.vue'
import ViewMail from '@v/bookings/details/tabs/tab-mails/ViewMail.vue'

export const bookingRoutes = [
  {
    path: '/bookings/:bookingKey/details',
    component: BookingTab,
    name: 'BookingView',
    props: true,
  },
  {
    path: '/bookings/:bookingKey/details/customer',
    component: CustomerTab,
    name: 'BookingCustomer',
    props: true,
  },
  {
    path: '/bookings/:bookingKey/details/visitors',
    component: VisitorsTab,
    name: 'BookingVisitors',
    props: true,
  },
  {
    path: '/bookings/:bookingKey/details/notes',
    component: NotesTab,
    name: 'BookingNotes',
    props: true,
  },
  {
    path: '/bookings/:bookingKey/details/payments',
    component: PaymentsTab,
    name: 'BookingPayments',
    props: true,
  },
  {
    path: '/bookings/:bookingKey/details/mail',
    component: MailsTab,
    name: 'BookingMail',
    props: true,
  },
  {
    path: '/bookings/:bookingKey/details/mail/:mailKey',
    component: ViewMail,
    name: 'ViewBookingMail',
    props: true,
  },
]
